import type { ComponentType } from "react";
import { shouldPolyfill } from "@formatjs/intl-listformat/should-polyfill";

import { APP_CONTAINER_ELEM_ID } from "@entries/constants";

async function intlListFormat() {
  if (shouldPolyfill("en")) {
    // polyfill must be imported before the locale data
    // per: https://formatjs.io/docs/polyfills/intl-listformat/#dynamic-import--capability-detection
    await import("@formatjs/intl-listformat/polyfill-force");
    await import("@formatjs/intl-listformat/locale-data/en");
  }
}

export async function waitForAndRender(
  factory: () => Promise<{ default: ComponentType }>,
): Promise<void> {
  try {
    await intlListFormat();
    const [{ renderWithContext }, componentModule] = await Promise.all([
      import("apps/root"),
      factory(),
    ]);
    renderWithContext(componentModule.default);
  } catch (error) {
    document.getElementById(APP_CONTAINER_ELEM_ID)!.textContent =
      "Something went wrong. Please try again.";
    throw error;
  }
}
